import { useEffect, useState } from "react";

import { api_without_cancellation } from "../../../api/api";

// null while checking; then {enabled, degraded, wsPath, seedSource, activeUsers, error?}
export function useCollabSession(docId) {
  const [session, setSession] = useState(null);
  useEffect(() => {
    if (!docId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await api_without_cancellation.post(`/api/collab/session/${docId}/`);
        if (cancelled) return;
        const d = res.data || {};
        setSession({
          enabled: !!d.collaboration_enabled,
          degraded: !!d.degraded,
          wsPath: d.ws_path,
          seedSource: d.seed_source, // "docx" | "yjs"
          activeUsers: d.active_users || [],
        });
      } catch (err) {
        if (cancelled) return;
        setSession({ enabled: false, error: err.response?.status || "network" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [docId]);
  return session;
}
